/* @ngInject */
const myDispositionsForm = (
  valueHandler,
  $$wagon,
  toaster
) => {
  return {
    restrict: 'E',
    scope: {
      myDispositions: '=',
      enableValidator: '=?',
    },
    template: require('./myDispositionsForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.addDecision = () => {
        $scope.myDispositions.push({ workshop: null, date: null, })
      }

      $scope.removeDecision = async (_index) => {
        $scope.myDispositions.splice(_index, 1)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

        // if (!valueHandler.isArray(scope.myDispositions)) {
        //   scope.myDispositions = []
        // }
      },
      post: (scope, element, attrs, ctrl) => {
        scope.$watch('myDispositions', (newDispositions, oldDispositions) => {
          if (newDispositions === undefined) {
            scope.myDispositions = []
          }

          if (newDispositions !== oldDispositions) {
            if (!valueHandler.isArray(newDispositions)) {
              scope.myDispositions = []
            } else {
              scope.myDispositions.splice(0, scope.myDispositions.length)
            }
          }
        })
      },
    },
  }
}
export default myDispositionsForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/forms/myDispositionsForm.js